
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { breakdanceUndo } from "@/lib/undo/undo";
import { snapshotStore } from "@/store/store";
import IconButton from "@/components/UI/IconButton.vue";
import { keyboardShortcuts } from "@/lib/keyboard-shortcuts/keyboard-shortcuts";
import { KEYBOARD_SHORTCUTS } from "@/lib/keyboard-shortcuts/global-shortcuts";
import TopBarSection from "@/components/Reusable/AppLayout/TopBar/TopBarSection.vue";
import { configStore } from "@/store/store";

@Component({
  components: {
    IconButton,
    TopBarSection
  }
})
export default class UndoRedo extends Vue {
  mounted() {
    keyboardShortcuts.register(KEYBOARD_SHORTCUTS.CMD_Z, this.undo);
    keyboardShortcuts.register(KEYBOARD_SHORTCUTS.CMD_SHIFT_Z, this.redo);
  }

  get canUndo() {
    return snapshotStore.canUndo;
  }

  get canRedo() {
    return snapshotStore.canRedo;
  }

  undo() {
    if (!this.canUndo) return;
    breakdanceUndo.undo();
  }

  redo() {
    if (!this.canRedo) return;
    breakdanceUndo.redo();
  }

  beforeDestroy() {
    keyboardShortcuts.unbind(KEYBOARD_SHORTCUTS.CMD_Z);
    keyboardShortcuts.unbind(KEYBOARD_SHORTCUTS.CMD_SHIFT_Z);
  }

  get builderMode() {
    return configStore.builderMode;
  }
}
